
const columns = (api) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '业务类型',
      name: 'bizType',
      searchItem: {
        type: 'select',
        initialValue: api.apiParams.bizType
      },
      tableItem: {},
      dict: [
        {code: 15, codeName: '报名'}
      ]
    },
    {
      title: '标题',
      name: 'title',
      searchItem: {},
      tableItem: {},
    },
    {
      title: '状态',
      name: 'state',
      searchItem: {
        type: 'select',
        initialValue: api.apiParams.state,
      },
      tableItem: {},
      dict: [
        {code: 0, codeName: '关闭'},
        {code: 1, codeName: '打开'}
      ]
    }
  ]
};

const tableApi = (api = {}) => {
  return {
    path: 'inviteLetter/list',
    ...api
  }
};

const inviteLetter = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(api),
    rowName: 'title',
    tableApi: tableApi(api)
  }
};

export default inviteLetter
